// Threats Module - DISABLED
// This module is disabled because the threats page now uses inline JavaScript
// in threats.html with full functionality including Edit/Delete buttons.
// The inline script handles all signature loading, editing, and deletion.

import { hasPermission } from '../utils/permissions.js';

export async function loadThreats() {
    // Check permission but do nothing - let the inline script handle it
    if (!hasPermission('view:threats')) {
        console.log('[Threats] No permission to view threats');
        return;
    }

    // The inline script in threats.html handles everything now
    console.log('[Threats] Module disabled - using inline script');
}

window.loadThreats = loadThreats;
